import CrudManager from "./CrudManager";

const fields = [
  { key: "name", label: "Name" },
  { key: "slug", label: "Slug (URL)" },
  { key: "icon", label: "Lucide icon name (Map, CalendarDays, Receipt, FlaskConical, Users, Truck)" },
  { key: "description", label: "Description", type: "textarea" },
];

export default function AdminCategories() {
  return (
    <CrudManager
      collection="categories"
      title="Categories"
      singular="category"
      fields={fields}
      listColumns={[
        { key: "name", label: "Name" },
        { key: "slug", label: "Slug" },
        { key: "description", label: "Description" },
      ]}
    />
  );
}
